import {Session, User} from "../types/Types";
import React from "react";
import {Link} from "react-router-dom";
import {getDateFromTimeStamp, getPhotoDate, getTime} from "../util/Util";
import UserTag from "../users/tag/UserTag";
import DateTime from "../date/DateTime";
import LocationTag from "../tag/LocationTag";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBolt} from "@fortawesome/free-solid-svg-icons";

interface Props {
    session: Session;
    user: User | undefined;
    displayName: boolean;
    displayLocation: boolean;
    displayBonus: boolean;
    timeSince?: string;
    distanceKm?: string;
    speedKmh?: number;
}

function SessionRow(props: Props) {

    const isCheckedIn = props.session && getDateFromTimeStamp(props.session.checkOutTime) > new Date() || false;

    return (
        <>
            <div className={`news-item`}>

                <div>
                    {props.displayName && <>
                        <div className={`d-inline-block`}>
                            {props.user &&
                                <UserTag
                                    user={props.user}
                                    visit={undefined}
                                    session={props.session}
                                    padRight={false}
                                    hideLocationDot={props.displayLocation}
                                    linksToTab={"sessions"}
                                    displayBonus={props.displayBonus}
                                />
                            }
                        </div>
                    </>}
                    {(props.displayName && props.displayLocation) && <>
                        <div className={"d-inline-block mr-1"}>
                            {!isCheckedIn && <span>checked into</span>}
                            {isCheckedIn && <span>is checked into</span>}
                        </div>
                    </>}
                    {props.displayLocation &&
                        <LocationTag
                            name={props.session.locationName}
                            id={props.session.locationId}
                            session={props.session}
                            displayVerificationTag={true}
                            linksToTab={"sessions"}
                        />
                    }
                </div>
                {(props.timeSince || props.distanceKm) ? (
                    <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted">
                            {props.timeSince && <span><b>{props.timeSince}</b></span>}
                            {props.timeSince && props.distanceKm && <span> | </span>}
                            {props.distanceKm && <span><b>{props.distanceKm}</b></span>}
                            {props.speedKmh !== undefined && props.speedKmh > 50 && <span> <FontAwesomeIcon icon={faBolt} /> <b>{Math.round(props.speedKmh)} km/h</b></span>}
                        </small>
                        <small className="ml-2 d-inline-block">
                            {getPhotoDate(props.session.checkInTime)} - {getTime(props.session.checkInTime)}
                        </small>
                    </div>
                ) : (
                    <DateTime date={props.session.checkInTime} />
                )}
            </div>
        </>
    )
}

export default SessionRow;